import { useEffect, useState } from 'react'

/**
 * 값이 안정될 때까지 갱신을 미룬다.
 * 검색 입력마다 API 를 호출하지 않도록 하는 용도.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, delayMs])

  return debounced
}

export default useDebouncedValue
